import { Container, Box, Stack, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

import ActionButton from "../account/ActionButton";
import ArrangementConfirmationInfoCard from "./ArrangementConfirmationInfoCard";

import ScrollToTop from "../nav/ScrollToTop";


/** 
 * The repayment plan confirmation page
 * */
function ArrangementConfirmation({ activeStep, steps }) {

  return (
    <>
      <ScrollToTop />
      <Stack
        sx={{
          mt: 2,
          mb: 5,
        }}
        spacing={2}
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        <Box
          id='payment-plan-container'
          sx={{ width: "100%", textAlign: "center", pt: 2, pb: 4 }}
        >
          <CheckCircle color='success' sx={{ fontSize: 72, mb: 2 }} />

          <Typography sx={{ fontWeight: "bold" }}>
            Payment plan confirmed
          </Typography>

          <Typography sx={{ py: 3, px: 1 }}>
            That's your plan setup, great stuff! Here's your summary of what you've agreed to repay, when, and how:
          </Typography>

          <Container sx={{ py: 2 }}>
            {
              /* Stepper process complete so render home link */
              activeStep === steps.length - 1 && (
                <ActionButton
                  id='return-home-btn'
                  buttonColor='primary.dark'
                  buttonTextColor='primary.contrastText'
                  buttonTitle='Return home'
                  hoverColor='primary.light'
                  hoverTextColor='primary.dark'
                  target='/'
                />
              )
            }
          </Container>
        </Box>

        <Box sx={{ width: { xs: "100%", md: "60%"} }}>
          <ArrangementConfirmationInfoCard />
        </Box>
      </Stack>
    </>
  );
}

export default ArrangementConfirmation;
